export default __webpack_public_path__ + "static/media/fitnessTracker.1f0e0619.jpg";